import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { TextareaModule } from 'primeng/textarea';

@Component({
    selector: 'app-historical-completion-dialog',
    standalone: true,
    templateUrl: './historical-completion-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule, ButtonModule, DatePickerModule, DialogModule, IftaLabelModule, InputGroupModule, InputGroupAddonModule, TextareaModule]
})
export class HistoricalCompletionDialogComponent {
    readonly visible = input(false);
    readonly completionDate = input<Date | null>(null);
    readonly overrideReason = input('');
    readonly saving = input(false);
    readonly visibleChange = output<boolean>();
    readonly completionDateChange = output<Date | null>();
    readonly overrideReasonChange = output<string>();
    readonly confirmed = output<void>();
}
